export const HTML_TEMPLATE = 'HTML_TEMPLATE'
export const HTML_NON_TEMPLATE = 'HTML_NON_TEMPLATE'
export const PDF = 'PDF'
export const IMAGE = 'IMAGE'

export const MENU_TYPE_OPTIONS = [
  { name: 'HTML Template', value: HTML_TEMPLATE },
  { name: 'HTML Non-Template', value: HTML_NON_TEMPLATE },
  { name: 'PDF', value: PDF },
  { name: 'Image', value: IMAGE },
]
